<script lang="ts" setup>
// ================================
// Composables
// ================================
const { t } = useI18n();

const steps = ref([
  {
    title: t('baseline.validation_step_1_title'),
    description: t('baseline.validation_step_1_description'),
    status: 'success',
  },
  {
    title: t('baseline.validation_step_2_title'),
    description: t('baseline.validation_step_2_description'),
    status: 'success',
  },
  {
    title: t('baseline.validation_step_3_title'),
    description: t('baseline.validation_step_3_description'),
    status: 'success',
  },
  {
    title: t('baseline.validation_step_4_title'),
    description: t('baseline.validation_step_4_description'),
    status: 'error',
  },
]);

const details = ref([
  {
    title: t('baseline.validation_detail_1_title'),
    value: 'Electricity',
  },
  {
    title: t('baseline.validation_detail_2_title'),
    value: 'Temperature, Occupancy',
  },
  {
    title: t('baseline.validation_detail_3_title'),
    value: 'Jan 2024 - Dec 2024',
  },
  {
    title: t('baseline.validation_detail_4_title'),
    value: 'Multivariate Linear',
  },
  {
    title: t('baseline.validation_detail_5_title'),
    value: 'Daily',
  },
  {
    title: t('baseline.validation_detail_6_title'),
    value: 'R² = 0.87 (Good)',
  },
]);
</script>
<template>
  <div>
    <div class="w-full bg-white rounded-lg p-4 border border-gray-200">
      <!-- Title -->
      <h2 class="text-lg font-bold">
        {{ $t('baseline.validation_title') }}
      </h2>
      <p class="text-sm text-gray-500">
        {{ $t('baseline.validation_description') }}
      </p>

      <div class="bg-gray-50 rounded-lg p-4 mt-4">
        <h2 class="mb-4 text-sm font-bold text-gray-500">
          {{ $t('baseline.finish_iso_50006_title') }}
        </h2>

        <!-- Steps -->
        <div v-for="step in steps" :key="step.title" class="flex items-start gap-4 mb-4">
          <div
            class="flex items-center justify-center w-8 h-8 bg-green-200/40 rounded-full"
            :class="{
              'bg-green-200/40': step.status === 'success',
              'bg-red-200/40': step.status === 'error',
            }"
          >
            <u-icon v-if="step.status === 'success'" name="i-lucide-check" class="text-green-500" />
            <u-icon v-else name="i-lucide-x" class="text-red-500" />
          </div>
          <div class="flex flex-col">
            <p class="font-bold text-gray-700">{{ step.title }}</p>
            <p class="text-sm text-gray-500">
              {{ step.description }}
            </p>
          </div>
        </div>
      </div>

      <div class="bg-gray-50 rounded-lg p-4 mt-4">
        <h2 class="mb-4 text-sm font-bold text-gray-500">
          {{ $t('baseline.validation_review_title') }}
        </h2>

        <div class="grid grid-cols-2 gap-4">
          <div v-for="detail in details" :key="detail.title">
            <p class="text-sm text-gray-600">
              {{ detail.title }}: <span class="font-bold text-gray-800">{{ detail.value }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full mt-8 flex flex-row justify-between">
      <u-button color="neutral" variant="outline" :label="$t('global.cancel')" @click="navigateTo('/references/baselines')" />
      <div class="flex items-center gap-2">
        <u-button
          color="neutral"
          variant="outline"
          :to="`/references/baselines/edit/${$route.params.id}/review`"
          :label="$t('global.previous')"
        />
        <u-button color="primary" variant="solid" :label="$t('global.finish')" />
      </div>
    </div>
  </div>
</template>
